
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
export default Vue.extend({
  components: { action },
  data() {
    return {
      items: [] as any[],
      spanArr: [] as number[], // 存放每一行要合并的行数
      pos: 0, // 当前分组起始索引
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret: any = await DeviceRequestBill.GetKpiList(content, 1, 1000);
      this.items = ret.data;
    },
    async insert() {
      await HttpUtil.XCHttpPost(Urls.CreateKpi, "", true, false);
      await this.getList();
    },
  },
});
